/**
 * Av/på-bryter for Gründerløftet-kampanjen.
 * Sett til true for å vise kampanjerammen, hero-feltet og footer-lenken igjen.
 * Siden /grunderloftet og alt innhold beholdes uansett.
 */
export const GRUNDERLOFTET_AKTIV = false;
